import TimeAgo from 'javascript-time-ago';
import pt from 'javascript-time-ago/locale/pt';

function getStringFromDate(date) {
  return 'dd/MM/yyyy'
    .replace(/dd/, `${date.getDate() < 10 ? '0' : ''}${date.getDate()}`)
    .replace(/MM/, `${date.getMonth() < 9 ? '0' : ''}${date.getMonth() + 1}`)
    .replace(/yyyy/, date.getFullYear());
}

function getDateFromString(dateString) {
  const dateParts = dateString.split('/');
  return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
}

function parseIsoDatetime(dateString) {
  const dt = dateString.split(/[:. T-]/).map(parseFloat);
  return new Date(dt[0], dt[1] - 1, dt[2], dt[3] || 0, dt[4] || 0, dt[5] || 0, 0);
}

function getDateTimeAgo(dateString) {
  TimeAgo.addLocale(pt);
  const timeAgo = new TimeAgo('pt-BR');
  return timeAgo.format(new Date(dateString)) === 'há 1 dia' ? 'ontem' : timeAgo.format(new Date(dateString));
}

const monthsAbbreviations = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
function abbreviateDate(date) {
  if (typeof date === 'string') {
    // eslint-disable-next-line no-param-reassign
    date = parseIsoDatetime(date);
  }
  return `${date.getDate()} ${monthsAbbreviations[date.getMonth()]}`;
}

export {
  getStringFromDate, getDateFromString, abbreviateDate, getDateTimeAgo,
};
